import type { IRecordTypeDefinition } from '@platform/core/types';

/** Порожнє значення поля (немає, порожній рядок або порожній масив). */
const empty = (value: unknown): boolean => value === null || value === undefined || (typeof value === 'string' && !value.trim()) || (Array.isArray(value) && !value.length);

/**
 * Обов'язкові поля типу, яких ще бракує значенням нового запису (статус дає сервер; назву — теж, якщо тип має автоназву), — як перевірка
 * сервера «порожнє обов'язкове → 400». Порожній список — запис можна створювати. Чиста функція.
 */
export function missingRequired(rt: Pick<IRecordTypeDefinition, 'fields' | 'titleAuto'>, values: Readonly<Record<string, unknown>>): string[] {
  return rt.fields.filter((f) => f.required && f.key !== 'status' && !(f.key === 'title' && rt.titleAuto) && empty(values[f.key])).map((f) => f.key);
}
